import React from 'react';
import './Referenzprojekte.css';

const ReferenzprojekteDownload: React.FC = () => (
  <section>
    <div className="container">
      <h2 className="page-heading">Referenzprojekte</h2>
      <div className="referenzprojekte-container">
        <a href="/docs/referenzprojekte.pdf" download>
          <button className="referenzprojekte-btn">Referenzprojekte</button>
        </a>
      </div>
    </div>
  </section>
);

export default ReferenzprojekteDownload;
